import Model from "@/models/Model";

export default class CompletedHomework extends Model {
    resource() {
        return "work";
    }

    markReviewed(reviewed) {
        if (reviewed) {
            return this.$http.put(
                this._fromResource + "/" + this.id + "/reviewed"
            );
        } else {
            return this.$http.delete(
                this._fromResource + "/" + this.id + "/reviewed"
            );
        }
    }
}
